import dayjs from 'dayjs';
import { useGetOptionsForCLA } from 'hooks/useGetOptionsForCLA';
import { isNil } from 'ramda';
import { useTranslation } from 'react-i18next';
import * as yup from 'yup';

import { CLAOption } from '../../CLA/SalaryScales/types';
import { IHolidaysSpecial } from './types';

import { singleSelectValueFormatter } from 'components/shared/DataGrid/utils/valueFormatters/singleSelectValueFormatter';

import { GridColumns } from '@mui/x-data-grid-pro';

import { Option } from 'components/shared/ControlledFields/ControlledSelect';
import { fullDateFormatter } from 'utils/grid';

export const useHolidaysSpecialColumns = () => {
  const { t } = useTranslation('common');

  const claOptions = useGetOptionsForCLA();

  return [
    {
      field: 'date',
      headerName: t('adminPortal.tables.date'),
      minWidth: 150,
      valueFormatter: fullDateFormatter
    },
    {
      field: 'description',
      headerName: t('name'),
      hideable: false,
      flex: 1
    },
    {
      field: 'claId',
      flex: 1,
      headerName: t('adminPortal.tables.cla'),
      type: 'singleSelect',
      valueOptions: claOptions,
      valueFormatter: (params) => singleSelectValueFormatter(params, claOptions)
    }
  ] as GridColumns;
};

const converterForDate = (date: Date) => dayjs(date).format('MMM D, YYYY');

export const convertResponseWithStringDate = (
  response: IHolidaysSpecial[] | undefined
) =>
  response
    ? response.map((data) => {
        return {
          ...data,
          date: converterForDate(data.date)
        };
      })
    : [];

export const schemaForHolidaysSpecial = (t) =>
  yup.object({
    date: yup
      .date()
      .required(
        t('validationFieldRequired', { name: t('adminPortal.tables.date') })
      )
      .default(new Date())
      .typeError(
        t('validationFieldRequired', { name: t('adminPortal.tables.date') })
      ),
    description: yup
      .string()
      .required(t('validationFieldRequired', { name: t('name') }))
      .default(''),
    claId: yup
      .number()
      .nullable()
      .required(
        t('validationFieldRequired', { name: t('adminPortal.tables.cla') })
      )
      .typeError(
        t('validationFieldRequired', { name: t('adminPortal.tables.cla') })
      )
  });

export const claDataToOption = (claData: CLAOption[]): Option[] => {
  if (!isNil(claData)) {
    return claData.map((item) => ({
      value: item.claId,
      label: item.code
    }));
  }
  return [];
};
